var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", [
        _c("div", { staticClass: "account-block" }, [
          _c("span", { staticClass: "account__subtitle" }, [
            _vm._v(_vm._s(_vm.$t(`account.edit.companyName`)))
          ]),
          _c("span", { staticClass: "account__text" }, [
            _vm._v(_vm._s(_vm.clientData.displayName || _vm.clientData.name))
          ])
        ]),
        _c("div", { staticClass: "account-block" }, [
          _c("span", { staticClass: "account__subtitle" }, [
            _vm._v(_vm._s(_vm.$t("nouns.CID")))
          ]),
          _c("span", { staticClass: "account__text" }, [
            _vm._v(_vm._s(_vm.clientData.cid))
          ])
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "profile-guard",
                rawName: "v-profile-guard",
                value: "components.dataAccount.edit.editAccount",
                expression: "'components.dataAccount.edit.editAccount'"
              }
            ],
            staticClass: "account__link"
          },
          [
            _c(
              "a",
              {
                on: {
                  click: function($event) {
                    _vm.openPopUp = true
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("actions.editDates")))]
            )
          ]
        )
      ]),
      _vm.openPopUp
        ? _c("PopUpCompany", {
            attrs: { "client-data": _vm.clientData },
            on: {
              "update-client": data => _vm.$emit("update-client", data),
              close: function($event) {
                _vm.openPopUp = $event
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }